import { Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { ModalController, NavController, } from '@ionic/angular';
import { ExtractDigitalAccountService } from '@wlp/ui-bs-cashout';
import {UserInfoService} from '@wlp/ui-bs-login';

import {UiBsTranslateService} from '@wlp/ui-bs-translate';

import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {LoadingService} from '../../../../../../../core/layout/services/loading.service';
import { InvestmentDetailsDto } from '@wlp/ui-bs-cashout/lib/dto/investment-details.dto';
import { Subject } from 'rxjs';
import { ModalIofComponent } from '../../../../modals/modal-iof/modal-iof.component';
import { ModalIrComponent } from '../../../../modals/modal-ir/modal-ir.component';

@Component({
  selector: 'app-investment-extract',
  templateUrl: './current.page.html',
  styleUrls: ['./current.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CurrentPage implements OnInit, OnDestroy {

  public brand: string;
  public wlName: string;
  public showBrand: boolean;

  
  public titleHeader: string = 'ASIDE_MENU.EXTRACT.INVESTMENT.SCREEN_TITLE';
  public extractInvestmentData: InvestmentDetailsDto;
  layoutConfigValue: LayoutConfigModel;
  langDefault: string;

  private destroy$: Subject<null> = new Subject();

  constructor(
    private navCtrl: NavController,
    private extractDigitalAccountService: ExtractDigitalAccountService,
    public loadingService: LoadingService,
    protected userInfoService: UserInfoService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private modalController: ModalController
  ) {

    this.brand = this.layoutConfigService.getConfig('wlTheme.header.billet.brand.logo');
    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.getDetailsInvestments();
  }

  getDetailsInvestments(){
    this.extractDigitalAccountService.getInvestmentDetails().subscribe(
      (res) => {
        this.extractInvestmentData = res;
      },
      (error) => console.error(error));
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }


  async openModalIof() {
    const modal = await this.modalController.create({
      component: ModalIofComponent,
      cssClass:"modal-custom-iof"
    });

    modal.onDidDismiss().then((data) => {
    });
    return await modal.present();
  }


    async openModalIR() {
    const modal = await this.modalController.create({
      component: ModalIrComponent,
      cssClass:'modal-custom-class',
    });
    modal.onDidDismiss().then((data) => {
    });
    return await modal.present();
  }

}
